import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGraphics3dDiverse {
    constructor() {

    }

    createMirror() {

    }

    createPivot() {
    }

    createPlane() {
    }

    getMatElement() {
    }

    loaderMatrix() {
    }

    trisRendered() {
    }

    vectorPitch() {
    }

    vectorYaw() {
    }
}
